import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'daysAgo', pure: true })
export class DaysAgoPipe implements PipeTransform {
  transform(value: Date | string | number): string {
    if (!value) {
      return '';
    }
    const then = new Date(value).setHours(0,0,0,0);
    const today = new Date().setHours(0,0,0,0);
    const diffMs = today - then;
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));
    if (diffDays < 0) {
      return '';  // future dates? hide or handle differently
    }
    if (diffDays === 0) {
      return 'today';
    }
    if (diffDays === 1) {
      return '1 day ago';
    }
    return `${diffDays} days ago`;
  }
}